import { groupBy } from 'lodash';

import { AshbyJob } from './ashby_types';

type Department = string;
const DEPT_SORT_ORDER: Department[] = [
  'Engineering',
  'Infrastructure',
  'Product Management',
  'Design',
  'Marketing',
  'User Operations',
  'Customer Support',
];

function compare_departments(a: Department, b: Department): number {
  const a_priority = DEPT_SORT_ORDER.indexOf(a);
  const b_priority = DEPT_SORT_ORDER.indexOf(b);
  return (
    (a_priority < 0 ? Infinity : a_priority) -
    (b_priority < 0 ? Infinity : b_priority)
  );
}

// Group jobs based on their departments, and sort the departments based on priority.
export default function categorize_and_sort_jobs(
  jobs: AshbyJob[],
): [Department, AshbyJob[]][] {
  const categorizedJobs = groupBy(jobs, (job) => job.team);
  const sortedKeys = Object.keys(categorizedJobs).sort(compare_departments);
  return sortedKeys.map((key) => [key, categorizedJobs[key]]);
}
